"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Institucional",
  description: "Construímos a base da sua identidade corporativa com design de alto impacto. Nossa abordagem foca em transmitir autoridade e profissionalismo, garantindo que sua marca se destaque no mercado com uma presença digital sólida e memorável.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/institucional_branding_studio.png",
  link: "/StudioPage"
}, {
  title: "Conteúdo Estratégico",
  description: "Impulsione seu crescimento com narrativas que conectam e convertem. Desenvolvemos estratégias de conteúdo focadas em engajamento social e expansão de marca, transformando seguidores em clientes leais através de design e storytelling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/strategic_content_growth.png",
  link: "/ServicesPage"
}];
function RevealImage({
  src,
  alt
}: {
  src: string;
  alt: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <div data-section-id="233769" ref={ref} className="absolute inset-0 w-full h-full overflow-hidden bg-muted">
      <img src={src} alt={alt} className={cn("w-full h-full object-cover transition-all duration-700 ease-out", isVisible ? "opacity-100 scale-100" : "opacity-0 scale-105")} />
    </div>;
}
export default function DetailedServiceList() {
  return <section id="serviços" className="bg-background text-foreground w-full overflow-hidden">
      <div className="flex flex-col w-full">
        {services.map((service, i) => <React.Fragment key={i}>
            <div data-index={i} className="grid grid-cols-1 lg:grid-cols-2 min-h-[500px] lg:min-h-[700px]">
              
              {/* Image Column */}
              <div className={cn("relative h-[400px] lg:h-auto w-full", i % 2 !== 0 ? "lg:order-2" : "lg:order-1")}>
                <RevealImage src={service.image} alt={service.title} />
              </div>

              {/* Content Column */}
              <div className={cn("flex flex-col justify-center p-8 md:p-16 lg:p-32 bg-background border-y border-border/50 lg:border-y-0 transition-all duration-200 ease-out hover:shadow-[0_0_40px_rgba(168,85,247,0.05)]", i % 2 !== 0 ? "lg:order-1" : "lg:order-2")}>
                <div className="max-w-xl mx-auto lg:mx-0">
                  <h3 className="font-default font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-6 tracking-tight">
                    {service.title}
                  </h3>
                  <p className="font-sans text-lg text-muted-foreground leading-relaxed mb-10">
                    {service.description}
                  </p>
                  <Link to={service.link} className="group relative inline-flex items-center font-sans font-medium text-primary pb-1 w-fit text-lg">
                    Saiba mais
                    <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-[2px] bg-primary transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                </div>
              </div>

            </div>
            
            {/* Separator */}
            {i < services.length - 1 && <div className="w-full px-8 lg:px-0">
                <Separator className="bg-border w-full h-[1px]" />
              </div>}
          </React.Fragment>)}
      </div>
    </section>;
}